import React, { ChangeEvent, Dispatch, FormEvent, SetStateAction, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';


interface AddDialogProps {
    isDialogOpen: boolean;
    isAddingFolder: boolean;
    newFolderName: string;
    newFileName: string;
    isEditMode: boolean;
    handleCancel: () => void;
    setNewFolderName: Dispatch<SetStateAction<string>>;
    setNewFileName: Dispatch<SetStateAction<string>>;
    handleCreateNewFolder: () => void;
    handleCreateNewFile: () => void;
    handleUpdateTreeItemName: () => void;
}

export const AddDialog: React.FC<AddDialogProps> = ({
    isDialogOpen,
    isAddingFolder,
    newFileName,
    newFolderName,
    isEditMode,
    handleCancel,
    setNewFolderName,
    setNewFileName,
    handleCreateNewFolder,
    handleCreateNewFile,
    handleUpdateTreeItemName,
}) => {
    const [error, setError] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>('');

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;


        if (value.startsWith('.')) {
            setError(true);
            setErrorMsg("Name cannot start with '.'");
        } else {
            setError(false);
            setErrorMsg('');
        }

        if (isAddingFolder) {
            setNewFolderName(value);
        } else {
            setNewFileName(value);
        }
    }

    const handleSubmit = (e: FormEvent<HTMLDivElement>) => {
        e.preventDefault();

        const value = isAddingFolder ? newFolderName : newFileName;

        if (value && !error) {
            setError(false);
            setErrorMsg('');
        }
        else if (!value) {
            setError(true);
            setErrorMsg("Name cannot be empty");
            return;
        }

        if (error) return;

        if (isEditMode) {
            handleUpdateTreeItemName();
        }
        else {
            isAddingFolder ? handleCreateNewFolder() : handleCreateNewFile();
        }
    }

    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCancel}
            component='form'
            onSubmit={handleSubmit}
            sx={{
                '& .MuiDialog-paperWidthSm': {
                    width: '500px',
                    maxWidth: '500px',
                    height: '230px'
                },
            }}
        >
            <DialogTitle>
                {isEditMode ? 'Update' : 'Add'} {isAddingFolder ? ' Folder' : ' File'}
            </DialogTitle>

            <DialogContent>
                <TextField
                    autoFocus
                    autoComplete='off'
                    margin="dense"
                    label={isAddingFolder ? 'Folder Name' : 'File Name'}
                    fullWidth
                    value={isAddingFolder ? newFolderName : newFileName}
                    onChange={handleChange}
                    error={error}
                    helperText={errorMsg}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCancel} type='button'>Cancel</Button>
                <Button type='submit'>OK</Button>
            </DialogActions>
        </Dialog>
    )
}
